/*
    gcUtils provides a set of methods to do geometry collection calculation and
    modifications
    (c) starshiptroopers.dev
 */

import {AMUtil} from "@/engine/leaflet/antimeridianUtils.js";

export const gcUtils = {
    /**
     * objFilter filters list of objects by filterExpression
     * filterExpr is expression presented as an array of operands and operations in RPN (reverse polish notation)
     * supported operations "O" - or, "A" - and, "!"
     * operands are a name of object's boolean properties or function that is called with object and returns filter result
     * example:
     *      objFilter(objcts, ["public", "!","mine", "writable", "O", "O"])
     *      returns objects where properties are "! public || mine || writable"
     *      another one:
     *      ["mine", "public", "O"] means (workspace.mine || workspace.public)
     * @param objects {Array}
     * @param filterExpr {Array | String}
     * @returns {*[]}
     */
    objFilter(objects, filterExpr) {
        // some testing template
        // let objs = [{id: 0, a: true},{id: 1, a:true},{id: 2, b:true},{id: 3, a: true, b:true},{id: 4, b:false, a:true}]

        if (typeof filterExpr == 'string') {
            filterExpr = [filterExpr]
        }

        let RPN_eval = function (expr, valueEvaluator) {
            let stack = []
            let el, right, left
            for (el of expr) {
                if (el === "A") {
                    right = stack.pop()
                    left = stack.pop()
                    stack.push(left && right)
                } else if (el === "O") {
                    right = stack.pop()
                    left = stack.pop()
                    stack.push(left || right)
                } else if (el === "!") {
                    left = stack.pop()
                    stack.push(!left)
                } else {
                    stack.push(valueEvaluator(el))
                }
            }
            return stack[0]
        }

        let o = []
        for (let obj of objects) {
            let value = RPN_eval(filterExpr, function (el) {
                if (typeof el === "function") {
                    return el(obj)
                } else if (typeof obj[el] === 'function') {
                    return obj[el]()
                } else {
                    return obj[el]
                }
            })

            if (value)
                o.push(obj)
        }
        return o;
    },

    /**
     * bounds returns bounds that cover all areas defined in objArray
     * @param onlyVisible
     * @param objArray
     * @returns {null}
     */
    bounds: function (onlyVisible, objArray) {
        if (onlyVisible) {
            objArray = this.objFilter(objArray, ["visible"])
        }
        let b = null;
        for (let i in objArray) {
            let lb = objArray[i].getBounds();

            if (lb === null) {
                continue
            }
            //fix possible antimeridian issue
            if (typeof AMUtil !== 'undefined')
                AMUtil.fixLng(lb);

            if (b == null) {
                b = L.latLngBounds(lb.getSouthWest(), lb.getNorthEast());
            } else {
                b.extend(lb);
            }
        }
        return b
    }
}
